import * as React from 'react'
import { FormattedMessage } from 'react-intl'

import styles from './hero.module.scss'

export default function Hero() {
  return (
    <div className={styles.root}>
      <div className={styles.outer}>
        <div className={styles.inner}>
          <h1 className={styles.heading}>
            <FormattedMessage defaultMessage="Press och media" id="press.hero.heading" />
          </h1>
        </div>
      </div>
    </div>
  )
}
